/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_Worth_TitleInputs */

const en_fw_guide_worth_title = /** @type {(inputs: Fw_Guide_Worth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Firefly Wedding worth watching?`)
};

const zh_fw_guide_worth_title = /** @type {(inputs: Fw_Guide_Worth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁值得看吗？`)
};

/**
* | output |
* | --- |
* | "Is Firefly Wedding worth watching?" |
*
* @param {Fw_Guide_Worth_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_worth_title = /** @type {((inputs?: Fw_Guide_Worth_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_Worth_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_worth_title(inputs)
	return zh_fw_guide_worth_title(inputs)
});
export { fw_guide_worth_title as "fw.guide.worth.title" }